import React from "react";
import { Globe, Briefcase, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
const services = [{
  title: "Visti Turistici",
  description: "Assistenza completa per l'ottenimento di visti turistici per ogni destinazione globale.",
  icon: Globe,
  details: "Gestiamo l'intera pratica burocratica, dalla verifica dei documenti necessari alla prenotazione degli appuntamenti presso i consolati competenti.",
  link: "/VisasAndImmigrationPage"
}, {
  title: "Visti Consolari",
  description: "Servizi specializzati per visti d'affari, transito e altre categorie consolari specifiche.",
  icon: Briefcase,
  details: "Supporto diretto per la legalizzazione di documenti e l'interfacciamento con le autorità diplomatiche per garantire tempi rapidi.",
  link: "/VisasAndImmigrationPage"
}];
export default function ServicesGrid() {
  return <section data-section-id="257187" id="services-overview" className="relative py-24 md:py-40 bg-white overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/diplomatic_architecture.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/diplomatic_architecture.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1663124/img/diplomatic_architecture.png-wvc-sizes" alt="Diplomatic Architecture" className="w-full h-full object-cover opacity-10" loading="lazy" />
        <div className="absolute inset-0 bg-gradient-to-b from-white via-white/95 to-white" />
      </div>

      {}
      <div className="absolute top-0 left-1/4 w-[600px] h-[600px] bg-secondary/5 rounded-lg mix-blend-screen filter blur-[140px] opacity-30 pointer-events-none" />
      <div className="absolute bottom-0 right-1/4 w-[500px] h-[500px] bg-secondary/10 rounded-lg mix-blend-screen filter blur-[120px] opacity-30 pointer-events-none" />

      <div className="page-container relative z-10 max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-8 mb-16 md:mb-24">
          <div className="max-w-2xl">
            <div className="inline-block mb-4 px-3 py-1 border border-secondary/30 bg-secondary/5 rounded-md">
              <span className="text-[10px] uppercase tracking-[0.2em] font-mono text-secondary font-bold">
                Institutional Services
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold text-primary mb-6 tracking-tighter leading-tight">
              Servizi Visti e <br />
              <span className="text-secondary">Pratiche Consolari</span>
            </h2>
            <p className="text-lg md:text-xl text-primary/70 font-sans font-light leading-relaxed">
              Esperti nella gestione di pratiche internazionali per privati e aziende, garantendo precisione, velocità e supporto costante nel panorama diplomatico globale.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12">
          {services.map((service, i) => <div key={i} data-index={i} className="group relative flex flex-col h-full bg-slate-50 border border-slate-200 rounded-lg p-8 md:p-12 transition-all duration-500 hover:border-secondary/40 hover:bg-white hover:shadow-xl">
              {}
              <div className="mb-8 inline-flex h-16 w-16 items-center justify-center rounded-lg bg-secondary/10 text-secondary border border-secondary/20 transition-all duration-500 group-hover:scale-110 group-hover:bg-secondary group-hover:text-primary shadow-sm">
                <service.icon className="h-8 w-8" strokeWidth={1} />
              </div>

              <h3 className="mb-4 text-2xl md:text-3xl font-serif font-bold text-primary leading-tight">
                {service.title}
              </h3>
              
              <p className="mb-6 text-primary/60 font-sans font-light text-lg leading-relaxed">
                {service.description}
              </p>

              <div className="mb-8 p-6 bg-slate-100 border-l-2 border-secondary/50 rounded-lg">
                <p className="text-sm md:text-base text-primary/80 font-sans italic leading-relaxed">
                  "{service.details}"
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}